import { useState, useEffect, useMemo } from 'react';
import jsonata from 'jsonata';
import {
  InteractionStepType,
  IndexedInteractionStepResponse,
  ChatJsonataContext,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';
import logger from 'react-scale/lib/logging';

export const useEvaluateEndSessionCondition = (
  expression: string | undefined,
  responses: IndexedInteractionStepResponse[],
  stepParams: StepParamsForTypeWithStage<InteractionStepType>,
): { evaluatedEndSessionCondition: boolean; isEvaluatingEndSessionCondition: boolean } => {
  const [evaluatedEndSessionCondition, setEvaluatedEndSessionCondition] = useState<boolean>(false);
  const [isEvaluatingEndSessionCondition, setIsEvaluatingEndSessionCondition] = useState(true);
  const jsonataContext: ChatJsonataContext = useMemo(
    () => ({ metadata: { responses }, stepParams }),
    [responses, stepParams],
  );

  useEffect(() => {
    const evaluateEndSessionCondition = async () => {
      try {
        if (expression) {
          setEvaluatedEndSessionCondition(await jsonata(expression).evaluate(jsonataContext));
        }
      } catch (error) {
        logger.warn(
          `[useEvaluateEndSessionCondition] Error evaluating jsonata: ${error.message}. This run will not include jsonata evaluations.`,
        );
      } finally {
        setIsEvaluatingEndSessionCondition(false);
      }
    };
    evaluateEndSessionCondition();
  }, [expression, jsonataContext]);
  return { evaluatedEndSessionCondition, isEvaluatingEndSessionCondition };
};

export default useEvaluateEndSessionCondition;
